<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="supplierManage.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="supplierManage"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="编号" prop="no">
              <el-input v-model="supplierManage.no" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input v-model="supplierManage.name" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="外部编号">
              <el-input v-model="supplierManage.outerNO" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="简称">
              <el-input v-model="supplierManage.shortName" :disabled="!editAuth" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="缩写">
              <el-input v-model="supplierManage.shortCode" :disabled="!editAuth" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="送货提前期">
              <el-input v-model="supplierManage.deliveryLeadtime" :disabled="!editAuth" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="supplierManage.contact" :disabled="!editAuth" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号">
              <el-input v-model="supplierManage.mobile" :disabled="!editAuth" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="传真">
              <el-input v-model="supplierManage.fax" :disabled="!editAuth" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮编">
              <el-input v-model="supplierManage.postCode" :disabled="!editAuth" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="地址">
              <el-input v-model="supplierManage.address" :disabled="!editAuth" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱">
              <el-input v-model="supplierManage.email" :disabled="!editAuth" placeholder="多个邮箱请用;隔开"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="送货方式">
                <div style="display: flex;flex-direction: row;">
                  <el-select v-model="supplierManage.deliveryType" :disabled="!editAuth" placeholder="请选择">
                    <el-option
                        v-for="item in deliveryTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发送未清订单">
                <div style="display: flex;flex-direction: row;">
                  <el-select v-model="supplierManage.sendOutstandingPo" :disabled="!editAuth" placeholder="请选择">
                    <el-option
                        v-for="item in sendOutstandingPoList"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"/>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="发送采购订单">
                <div style="display: flex;flex-direction: row;">
                  <el-select v-model="supplierManage.sendPo" :disabled="!editAuth" placeholder="请选择">
                    <el-option
                        v-for="item in sendPoList"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"/>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发送PDF">
                <div style="display: flex;flex-direction: row;">
                  <el-select v-model="supplierManage.sendPoPDF" :disabled="!editAuth" placeholder="请选择">
                    <el-option label="是" :value="true"/>
                    <el-option label="否" :value="false"/>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input v-model="supplierManage.note" type="textarea" :disabled="!editAuth" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <div class="editTitle" style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
          <span>供应商合同<el-button v-if="editAuth" type="primary" size="small" icon="el-icon-plus" @click="handleContractAdd">新建</el-button></span>
        </div>
        <el-table border :data="supplierManage.contractList" style="margin-top:10px">
          <el-table-column type="index" align="center" label="#" width="55"/>
          <el-table-column align="center" label="合同编号" min-width="400">
            <template slot-scope="scope">
              <el-input v-model="scope.row.contractNo" size="small" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column v-if="editAuth" align="center" label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="handleContractDelete(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span v-if="editAuth" slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";

  export default {
    name: "SupplierManageEdit",
    components: {},
    data() {
      return {
        constant,
        editAuth: false,
        deliveryTypes: constant.toSelect(constant.deliveryType),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        supplierManage: {
          pkid: "",
          no: "",
          name: "",
          outerNO: "",
          shortName: "",
          shortCode: "",
          contact: "",
          mobile: "",
          fax: "",
          postCode: "",
          address: "",
          email: "",
          note: "",
          deliveryType: "",
          deliveryLeadtime: "",
          sendOutstandingPo: "",
          sendPo:"",
          sendPoPDF:"",
          contractList:[],
        },
        sendOutstandingPoList:[
          {label:"是",value:true},
          {label:"否",value:false},
        ],
        sendPoList:[
          {label:"是",value:true},
          {label:"否",value:false},
        ],
        ruleValidate: {
          name: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(id, edit) {
        this.editAuth = edit;
        this.supplierManage.pkid = id;
        console.log(id);
        this.dialogVisible = true;
        if (id > 0) {
          this.getData();
        } else {
          this.getNode();
        }
      },

      handleContractAdd() {
        if (!this.supplierManage.contractList) {
          this.$set(this.supplierManage, "contractList", []);
        }
        this.supplierManage.contractList.push({
          contractNo: "",
          contractName: "",
          contractAmount: "",
          signDate: "",
          startDate: "",
          endDate: "",
          status: "",
        });
      },

      handleContractDelete(index) {
        this.$confirm("确定删除该合同吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.supplierManage.contractList.splice(index, 1);
          this.$message.success("删除成功");
        }).catch(() => {});
      },

      getData() {
        this.$http
          .get("basic", `supplierInfoes/${this.supplierManage.pkid}`)
          .then(resp => {
            //console.log(resp);
            if (!resp.contractList) {
              resp.contractList = [];
            }
            this.supplierManage = resp;
          });
      },
      getNode() {
        this.$http
          .get("basic", "supplierInfoes/selectNo")
          .then(resp => {
            console.log(resp);
            this.supplierManage.no = resp;
          });
      },

      handleSubmit() {
        if (this.supplierManage.pkid > 0) {
          this.handleSubmitPut();
        } else {
          this.handleSubmitPost();
        }
      },
      handleSubmitPut() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "supplierInfoes", this.supplierManage)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitPost() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "supplierInfoes", this.supplierManage)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
